<template>
  <section class="step5-form" :style="{minHeight:(screenHeight-85)+'px'}">
    <div class="step-form__step-num">5/5</div>
    <div class="step-form__main">
      <h1 class="step-form__title">提交成功</h1>
      <div class="step5-form__form">
        <div class="step5-form__success-message">资料提交成功，请等待审核</div>
      </div>
    </div>
  </section>
</template>
<script>
  import _ from 'lodash'

  export default {
    data () {
      return {
        screenHeight: document.body.clientHeight
      }
    },
    beforeRouteLeave (to, from, next) {
      if (to.path.indexOf('applyLoan') !== -1) {
        next(false)
      } else {
        next()
      }
    },
    mounted () {
      this.$store.commit('changeActive', 5);
      _.delay(() => {
        this.$router.push('/personalCenter/myLoan')
      }, 3000)
    }
  }
</script>
<style lang="scss">
  .step5-form__form {
    @include clear;
    padding: 210px 0;
  }

  .step5-form__success-message {
    @include clear;
    position: relative;
    /*left: 50%;
    float: left;
    transform: translate(-50%, 0);*/
    width: 390px;;
    margin: 0 auto;
    font: 24px/70px "FZLanTingHei-DB-GBK", "Microsoft YaHei";

    &:before {
      content: '';
      float: left;
      display: block;
      margin-right: 24px;
      width: 70px;
      height: 70px;
      background: url('../../../static/images/icons/success_alert_icon.png') #fff no-repeat;
      background-size: cover;
    }
  }
</style>



// WEBPACK FOOTER //
// Step5_bak.vue?6ccd69ff